import React from 'react';
import { TierNote } from '../TierNote';
interface DirectoryColumnsProps {
  title: string;
  groups: {
    area: string;
    items: string[];
  }[];
}
export function DirectoryColumns({
  title,
  groups
}: DirectoryColumnsProps) {
  return <section aria-labelledby="tier3-h" className="bg-paper" data-id="element-102" data-mp="e9ygyxgw7adl">
      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-24" data-id="element-103" data-mp="a725rrtomgjo">
        <TierNote tier="3" label="Directory lines" note="Two minutes each. Makes the page genuinely complete so nobody leaves to check another site." data-id="element-104" data-mp="a9y25bpvsx60" />
        <h2 id="tier3-h" className="max-w-2xl font-display text-[38px] font-300 leading-[1.05] text-ink sm:text-[46px]" data-id="element-105" data-mp="j65ouvsumvy6">
          {title}
        </h2>

        <div className="mt-14 grid gap-x-14 gap-y-12 border-t border-line pt-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-106" data-mp="syl4vnkl5agf">
          {groups.map(group => <nav key={group.area} aria-label={group.area} data-id="element-107" data-mp="11z9mes96tsy2">
              <h3 className="label text-muted" data-id="element-108" data-mp="11wohfudleww3">{group.area}</h3>
              <ul className="mt-5 space-y-3" data-id="element-109" data-mp="1ebh0xs1xeoi6">
                {group.items.map(item => <li key={item} data-id="element-110" data-mp="1jajvgika5cbw">
                    <a href="#faq" className="text-[14.5px] leading-snug text-ink/80 underline-offset-4 transition-colors duration-150 ease-soft hover:text-olive hover:underline" data-id="element-111" data-mp="1j9qxa5zdzv5d">
                      {item}
                    </a>
                  </li>)}
              </ul>
            </nav>)}
        </div>
      </div>
    </section>;
}